var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg-logout",
    transform: "translate(-383 -5018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "form",
    transform: "translate(383 5018)",
    fill: "none",
    stroke: "#f24e59",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "logout_Kopie_2",
    "data-name": "logout Kopie 2",
    d: "M5.612,24.053a5.551,5.551,0,0,1-5.605-5.24L0,18.563V5.5A5.538,5.538,0,0,1,5.348,0L5.6,0h5.848a5.55,5.55,0,0,1,5.607,5.237l.005,1.354a1.2,1.2,0,0,1-2.386.159l-.009-.14V5.5a3.18,3.18,0,0,0-3.027-3.145l-.2,0H5.612A3.19,3.19,0,0,0,2.4,5.312L2.4,5.5V18.556A3.181,3.181,0,0,0,5.423,21.7l.2.005h5.843a3.176,3.176,0,0,0,3.2-2.952l.006-1.292a1.2,1.2,0,0,1,2.386-.157l.009.138v1.126a5.53,5.53,0,0,1-5.33,5.479l-.263.006Zm14.037-7.778a1.161,1.161,0,0,1-.113-1.528l.1-.114L21.1,13.2H9.579a1.172,1.172,0,0,1-.163-2.336l.143-.009H21.105L19.652,9.437a1.161,1.161,0,0,1-.118-1.528l.1-.114a1.231,1.231,0,0,1,1.576-.133l.118.1,3.511,3.42a1.148,1.148,0,0,1,.367.845,1.17,1.17,0,0,1-.376.854l-3.485,3.4a1.217,1.217,0,0,1-1.694,0Z",
    transform: "translate(395.398 5030.978)",
    fill: "#f24e59"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgLogout);
export default __webpack_public_path__ + "static/media/svg-logout.0dbecf9ef5465099df7ad60ad0807435.svg";
export { ForwardRef as ReactComponent };